import { memo } from 'react';

import MakeIcon from '@/assets/make-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type MakeLogoProps = LogoProps;

const IMakeLogo = ({ className, ...rest }: MakeLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <MakeIcon className="size-5" />
    </Logo>
  );
};

export const MakeLogo = memo(IMakeLogo) as typeof IMakeLogo;
